import lodashKeys from 'lodash-es/keys';
import lodashPickBy from 'lodash-es/pickBy';
import type { WritableComputedRef, Ref, ComputedRef } from 'vue';
import type { LocationQuery } from 'vue-router';

import { EMPTY_OPTION_VALUE } from '~/constants/filters';
import type { EmptyOptionValue } from '~/types/filters';

export const prependEmptyOption = <T>(
    options: { value: T; label: string }[],
    emptyLabel: string
): { value: T | EmptyOptionValue; label: string }[] => [{ value: EMPTY_OPTION_VALUE, label: emptyLabel }, ...options];

export const adaptEmptyOptionModel = <T>(ref: Ref<T | undefined>): WritableComputedRef<T | typeof EMPTY_OPTION_VALUE> =>
    computed({
        get: () => (ref.value === undefined ? EMPTY_OPTION_VALUE : ref.value),
        set: value => (ref.value = value === EMPTY_OPTION_VALUE ? undefined : value),
    });

export const getOptionsValidValues = <T>(options: ComputedRef<{ value: T }[]>): ComputedRef<Set<T>> =>
    computed(() => new Set(options.value.map(el => el.value)));

export const validateOptionValue = <T>(queryValue: LocationQuery[string], validValues: Set<T>): T | undefined => {
    const [firstOption] = validValues;
    const value = typeof firstOption === 'number' ? locationQueryAsOptionalNumber(queryValue) : locationQueryAsOptionalString(queryValue);

    return value && validValues.has(value as T) ? (value as T) : undefined;
};

export const getMultivaluedSelectedValues = <T extends string>(filterModel: Record<T, WritableComputedRef<boolean>>): T[] =>
    lodashKeys(lodashPickBy(filterModel, (r: WritableComputedRef<boolean>) => r.value)) as T[];
